module.exports = __webpack_public_path__ + "img/rose.92968360.png";